/**
 * Karved Concepts — Scroll Animation Observer
 * Adds .kc-is-visible to [data-animate] elements as they enter the viewport.
 * Also triggers hero on-load class and count-up animations for B2B stats.
 */
(function () {
  'use strict';

  const THRESHOLD = 0.15; // 15% of element visible before animating

  function initScrollAnimations() {
    const targets = document.querySelectorAll('[data-animate]');
    if (!targets.length) return;

    // Apply data-animate-delay from attribute as inline style
    targets.forEach(function (el) {
      var delay = el.getAttribute('data-animate-delay');
      if (delay) {
        el.style.transitionDelay = delay + 'ms';
      }
    });

    // Content is visible by default (see karved-animations.css). Without
    // IntersectionObserver we never add kc-reveal-ready, so nothing hides.
    if (!('IntersectionObserver' in window)) return;

    // Arm the hidden state on the first scroll only, so a visitor (or
    // crawler, or full-page capture) that never scrolls sees everything.
    window.addEventListener('scroll', function () { armReveal(targets); }, { once: true, passive: true });
  }

  function armReveal(targets) {
    function revealAll() {
      targets.forEach(function (el) { el.classList.add('kc-is-visible'); });
    }

    // Mark anything already in view before the hidden state can apply.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var pending = [];
    targets.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) {
        el.classList.add('kc-is-visible');
      } else {
        pending.push(el);
      }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kc-is-visible');
          observer.unobserve(entry.target); // fire once
        }
      });
    }, { threshold: THRESHOLD });

    document.documentElement.classList.add('kc-reveal-ready');
    pending.forEach(function (el) { observer.observe(el); });

    // Failsafe: never leave content hidden if the observer does not fire.
    if (document.readyState === 'complete') {
      setTimeout(revealAll, 1500);
    } else {
      window.addEventListener('load', function () { setTimeout(revealAll, 1500); });
    }
    setTimeout(revealAll, 3000);
  }

  function initHeroAnimation() {
    var hero = document.querySelector('.hero-karved');
    if (hero) {
      hero.classList.add('kc-hero-animate');
    }
  }

  function initCountUp() {
    var statEls = document.querySelectorAll('.b2b-cta__stat-value[data-countup]');
    if (!statEls.length) return;

    var countUpObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var end = parseFloat(el.getAttribute('data-countup'));
        var isInt = el.getAttribute('data-countup-int') === 'true';
        var suffix = el.getAttribute('data-countup-suffix') || '';
        var duration = 1200;
        var start = performance.now();

        function step(now) {
          var elapsed = now - start;
          var progress = Math.min(elapsed / duration, 1);
          // ease-out cubic
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = end * eased;
          el.textContent = (isInt ? Math.round(current) : current.toFixed(1)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
        countUpObserver.unobserve(el);
      });
    }, { threshold: 0.5 });

    statEls.forEach(function (el) { countUpObserver.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initHeroAnimation();
      initScrollAnimations();
      initCountUp();
    });
  } else {
    initHeroAnimation();
    initScrollAnimations();
    initCountUp();
  }
})();
